import { unref } from 'vue'
import { buildProps } from '@element-plus/utils'
import { useTimeout } from '../use-timeout'

import type { ExtractPropTypes, ToRefs } from 'vue'

export const useDelayedToggleProps = buildProps({
  showAfter: {
    type: Number,
    default: 0,
  },
  hideAfter: {
    type: Number,
    default: 200,
  },
} as const)

export type UseDelayedToggleProps = {
  open: (event?: Event) => void
  close: (event?: Event) => void
  cancelCloseTimer?: boolean
} & ToRefs<ExtractPropTypes<typeof useDelayedToggleProps>>

export const useDelayedToggle = ({
  showAfter,
  hideAfter,
  cancelCloseTimer,
  open,
  close,
}: UseDelayedToggleProps) => {
  const { registerTimeout, cancelTimeout } = useTimeout()

  const onOpen = (event?: Event) => {
    cancelCloseTimer && cancelTimeout()
    if (!unref(showAfter)) {
      open(event)
      return
    }
    registerTimeout(() => {
      open(event)
    }, unref(showAfter))
  }

  const onClose = (event?: Event) => {
    registerTimeout(() => {
      close(event)
    }, unref(hideAfter))
  }

  return {
    onOpen,
    onClose,
  }
}
